import { RichText } from "@/components/RichText";
import type { Workforce as Data } from "@/lib/types";

export default function Workforce({ data }: { data: Data }) {
  return (
    <section className="workforce" id="workforce">
      <div className="workforce-inner">
        <div className="section-header">
          <span className="section-eyebrow">{data.eyebrow}</span>
          <RichText as="h2" className="section-title" html={data.title} />
          <p className="section-sub">{data.sub}</p>
        </div>
        <div className="agents-grid">
          {data.agents.map((agent) => (
            <div className="agent-card" key={agent.name}>
              <div className="agent-head">
                <div className="agent-name">{agent.name}</div>
                <div className="agent-role">{agent.role}</div>
              </div>
              <RichText as="p" className="agent-desc" html={agent.desc} />
              <div className="agent-stats">
                {agent.stats.map((stat) => (
                  <div className="agent-stat" key={stat.label}>
                    <div className="agent-stat-num">{stat.num}</div>
                    <div className="agent-stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="next-up">
          <span className="next-up-label">{data.nextUp.label}</span>
          <RichText as="span" html={data.nextUp.body} />
        </div>
      </div>
    </section>
  );
}
